export default {
  methods: {
    computeAmount(extra, params) {
      let nights = this.$moment(params.end_date).diff(this.$moment(params.start_date), 'days');
      let weeks = Math.ceil(nights / 7);
      let guests = parseInt(params.guests) || 0;

      if (extra.type === this.$const('ConstExtraTypes', 'PER_DAY')) {
        return parseFloat(extra.amount * nights);
      }

      if (extra.type === this.$const('ConstExtraTypes', 'PER_RESERVATION')) {
        return parseFloat(extra.amount);
      }

      if (extra.type === this.$const('ConstExtraTypes', 'PER_WEEK')) {
        return parseFloat(extra.amount * weeks);
      }

      if (extra.type === this.$const('ConstExtraTypes', 'PER_PERSON_RESERVATION')) {
        return parseFloat(extra.amount * guests);
      }

      if (extra.type === this.$const('ConstExtraTypes', 'PER_PERSON_DAY')) {
        return parseFloat(extra.amount * guests * nights);
      }

      if (extra.type === this.$const('ConstExtraTypes', 'PER_PERSON_WEEK')) {
        return parseFloat(extra.amount * guests * weeks);
      }

      if (extra.type === this.$const('ConstExtraTypes', 'PERCENTAGE_ON_AMOUNT')) {
        return parseFloat(parseFloat(params.amount) / 100 * extra.amount);
      }

      return parseFloat(extra.amount);
    },
  },
};
